exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".login[data-v-1f96042c]{min-height:100vh;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:24px;background:#101622}.card[data-v-1f96042c]{width:420px;max-width:100%;padding:22px;border-radius:14px;background:#1a2235;border:1px solid #232f48;box-shadow:0 10px 30px rgba(0,0,0,.08)}.brand[data-v-1f96042c]{margin-bottom:12px}.title[data-v-1f96042c]{font-size:20px;font-weight:900;color:#fff}.sub[data-v-1f96042c]{margin-top:6px;font-size:12px;color:#92a4c9}.actions[data-v-1f96042c]{margin-top:10px;display:-ms-grid;display:grid;gap:6px}.hint[data-v-1f96042c]{margin-top:12px;font-size:12px;color:#92a4c9}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1f96042c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/auth/Login.vue
// module id = 426
// module chunks = 0